import { useClientHandle } from '@urql/vue'
import {
  EntityTextFieldValuesDocument,
  type EntityTextFieldValue,
  type TranslatableEntityType,
} from '~/graphql/operations'

export type FetchValuesArgs = {
  entityType: TranslatableEntityType
  entityId: number
  languageId: number
  channelId?: number | null
}

export const useEntityTextFieldValues = () => {
  const { client } = useClientHandle()

  const loading = ref(false)
  const error = ref<Error | null>(null)

  const fetchValues = async (
    args: FetchValuesArgs,
  ): Promise<EntityTextFieldValue[]> => {
    loading.value = true
    error.value = null
    try {
      const result = await client
        .query(
          EntityTextFieldValuesDocument,
          {
            entityType: args.entityType,
            entityId: args.entityId,
            languageId: args.languageId,
            channelId: args.channelId ?? null,
          },
          { requestPolicy: 'network-only' },
        )
        .toPromise()
      if (result.error) throw result.error
      return result.data?.entityTextFieldValues || []
    } catch (e: any) {
      const err = e instanceof Error ? e : new Error(String(e?.message || e))
      error.value = err
      throw err
    } finally {
      loading.value = false
    }
  }

  return {
    fetchValues,
    loading: computed(() => loading.value),
    error: computed(() => error.value),
  }
}
